// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Form, FormGroup, Col, FormControl, Button, ControlLabel, Row, Alert } from 'react-bootstrap'
import { Link } from 'react-router'
import CSVReader from "react-csv-reader"
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import config from '../config/config.json'
import { validateEmail, printableJsonError } from '../utils/enUtils.js'

export class AddWorker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            formAlertType: 'danger',
            formAlertDisplay: 'none',
            formAlertText: '',
            emailError: null,
            errorIndividual: 'Individual invite error: ',
            errorBulk: 'Bulk Upload file invalid: ',
            csvData: []
        }

        this.init()

        this.init = this.init.bind(this)
        this.handleOnSingleSubmit = this.handleOnSingleSubmit.bind(this)
        this.sendInvites = this.sendInvites.bind(this)
        this.handleFileSelection = this.handleFileSelection.bind(this)
        this.handleFileData = this.handleFileData.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                company: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    clearFormAlert() {
        this.formAlertUpdate('success', 'none', '')
    }

    handleInputChange(e) {
        this.clearFormAlert()
    }

    handleOnSingleSubmit(e) {
        e.preventDefault()
        let workerData = []
        let formData = {
            'first_name': this.fnameInput.value,
            'last_name': this.lnameInput.value,
            'category1': this.category1Input.value,
            'email': this.emailInput.value
        }

        if (!formData.first_name) {
            this.formAlertUpdate('danger', 'block', this.state.errorIndividual + "Please enter a first name")
        } else if (!formData.last_name) {
            this.formAlertUpdate('danger', 'block', this.state.errorIndividual + "Please enter a last name")
        } else if (!formData.email) {
            this.formAlertUpdate('danger', 'block', this.state.errorIndividual + "Please enter an email address")
        } else if (!validateEmail(formData.email)) {
            this.formAlertUpdate('danger', 'block', this.state.errorIndividual + "Email address is not valid")
        } else {
            workerData.push((formData))
            this.sendInvites((workerData))
        }
    }

    handleFileSelection(data) {
        this.clearFormAlert()
        //console.log(data)
        this.setState({
            csvData: data
        })
    }

    handleFileData(e) {
        e.preventDefault()

        let workers = []
        let csvValid = true

        if (this.state.csvData) {
            if (this.state.csvData.length === 0) {
                this.formAlertUpdate('danger', 'block', this.state.errorBulk + "File is empty")
                csvValid = false
            } else {
                for (let i = 0; i < this.state.csvData.length; i++) {
                    let row = this.state.csvData[i]

                    if (row.length === 1 && row[0].trim() === "") {
                        // Ignore blank rows
                    } else {
                        let rowError = this.validateRow(row, i + 1)

                        if (rowError === null) {
                            workers.push({
                                'first_name': row[0],
                                'last_name': row[1],
                                'category1': row[2],
                                'email': row[3]
                            })
                        } else {
                            // Exit loop on first error and report error message
                            this.formAlertUpdate('danger', 'block', this.state.errorBulk + rowError)
                            csvValid = false
                            break
                        }
                    }
                }

                if (csvValid) {
                    if (workers.length > 0) {
                        this.sendInvites(workers)
                    } else {
                        // File had blank lines
                        this.formAlertUpdate('danger', 'block', this.state.errorBulk + "File is empty")
                    }
                }
            }
        }
    }

    // Validate a row in the CSV file. Return null if the row is valid; otherwise, return an error message.
    validateRow(row, rowNum) {
        if (row.length !== 4) {
            return "Does not have 4 columns on row " + rowNum
        } else {
            let first_name = row[0]
            let last_name = row[1]
            // row[2] is category1 - this can be blank (optional)
            let email = row[3]

            if (!first_name) {
                return "First name is empty on row " + rowNum
            } else if (!last_name) {
                return "Last name is empty on row " + rowNum
            } else if (!email) {
                return "Email is empty on row " + rowNum
            } else if (!validateEmail(email)) {
                return `Invalid email address on row ${rowNum} - '${email}'`
            }
        }

        return null
    }

    sendInvites(workers) {
        let worker_connection = { "workers": workers }

        fetch(config[this.props.env] + config.api.connect_worker.endpoint, {
            method: config.api.connect_worker.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.data.authToken
            },
            body: JSON.stringify(
                worker_connection: worker_connection
            )
        }).then((response) => response.json())
            .then((responseJson) => {
                ('errors' in responseJson || 'error' in responseJson) ? this.unsuccessfulInvitation(responseJson) : this.successfulInvitationSent(workers.length, responseJson)
            })
            .catch((error) => {
                console.error(error)
            });
    }

    unsuccessfulInvitation(responseJson) {
        let errorMessage = "Unknown error"
        if ('errors' in responseJson) {
            errorMessage = printableJsonError(responseJson.errors)
        } else if ('error' in responseJson) {
            errorMessage = printableJsonError(responseJson.error)
        }
        this.formAlertUpdate('danger', 'block', errorMessage)
    }

    successfulInvitationSent(numInvitesSent, responseJson) {
        if ('message' in responseJson) {
            this.formAlertUpdate('success', 'block', responseJson.message)
        } else {
            this.formAlertUpdate('success', 'block', numInvitesSent + ' invitations sent successfully')
        }
        this.setState({
            emailError: null
        })

        document.getElementById('addWorker').reset()
    }

    formAlertUpdate(type, display, text) {
        this.setState({
            formAlertType: type,
            formAlertDisplay: display,
            formAlertText: text
        })
    }

    get remainingLicenses() {
        let totalUsers = this.data.workers.length

        return parseInt(this.data.licenseCount, 10) - totalUsers
    }

    prepareBreadcrumb() {
        return (
            <div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>
        )
    }

    render() {
        this.data = this.props.appData

        return (
            <div className="addworker-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.data}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={3}
                />

                <div className="main-body">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                {this.prepareBreadcrumb()}
                                <h2 className="title">Add Workers</h2>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                                <h3>{this.state.formAlertType === 'danger' ? "Something went wrong!" : "Success!"}</h3>
                                <p className="alert-text">{this.state.formAlertText}</p>
                            </Alert>
                        </Col>
                    </Row>
                    <Form horizontal className="addworker-form" id="addWorker">
                        <FormGroup controlId="formHorizontalFName">
                            <Col componentClass={ControlLabel} sm={4}>
                                First Name
                            </Col>
                            <Col sm={5}>
                                <FormControl type="text" placeholder="First Name" inputRef={ref => { this.fnameInput = ref }} onChange={this.handleInputChange} />
                                <FormControl.Feedback />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalLName">
                            <Col componentClass={ControlLabel} sm={4}>
                                Last Name
                            </Col>
                            <Col sm={5}>
                                <FormControl type="text" placeholder="Last Name" inputRef={ref => { this.lnameInput = ref }} onChange={this.handleInputChange} />
                                <FormControl.Feedback />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalCat1">
                            <Col componentClass={ControlLabel} sm={4}>
                                Category
                            </Col>
                            <Col sm={5}>
                                <FormControl type="text" placeholder="Category (optional)" inputRef={ref => { this.category1Input = ref }} onChange={this.handleInputChange} />
                                <FormControl.Feedback />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail" validationState={this.state.emailError}>
                            <Col componentClass={ControlLabel} sm={4}>
                                Email
                            </Col>
                            <Col sm={5}>
                                <FormControl type="email" placeholder="Email" inputRef={ref => { this.emailInput = ref }} onChange={this.handleInputChange} />
                                <FormControl.Feedback />
                            </Col>
                        </FormGroup>

                        <hr className="invisible post-form" />
                        <FormGroup>
                            <Col smOffset={4} sm={4}>
                                <Button type="submit" bsStyle="primary" onClick={this.handleOnSingleSubmit}>
                                    Send Invite
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                    <Row>
                        <Col smOffset={3} sm={6} bsClass="divider col">
                        </Col>
                    </Row>
                    <Row>
                        <Form horizontal className="addworker-form-bulk">
                            <FormGroup>
                                <Row>
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Bulk Format
                                    </Col>
                                    <Col sm={5}>
                                        <div className="addWorkerHelp">CSV-only with no header: First name, last name, category (can be blank), email
                                            <a href="https://enabler-reference.s3.ap-southeast-2.amazonaws.com/customer_support/enabler_bulk_user_upload_example.csv">(download template)</a>
                                        </div>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Bulk Upload
                                    </Col>
                                    <Col className="bulkUpload" sm={4}>
                                        <CSVReader
                                            cssClass="react-csv-input"
                                            onFileLoaded={this.handleFileSelection}
                                        />
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col sm={4}>
                                    </Col>
                                    <Col sm={5}>
                                        <button className='btn btn-primary' type='submit' onClick={this.handleFileData}>
                                            Upload from CSV
                                        </button>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/addWorker.js